import { useCallback, useEffect, useState } from 'react';
import type { Tenant } from '@core/api/tenant';
import { useAuth } from '@core/contexts/AuthContext';
import { useBrand } from '@core/contexts/BrandContext';
import { UserRole } from '@core/enum/userRole';
import {
  clearTenantSession,
  readTenantSession,
  writeTenantSession,
} from '@core/utils/tenantSession';

export function useTenantSession() {
  const { user } = useAuth();
  const { tenancyEnabled = false } = useBrand();
  const [tenant, setTenant] = useState<Tenant | null>(readTenantSession);
  const canSwitch = Boolean(
    tenancyEnabled && user?.role === UserRole.SuperAdmin
  );

  useEffect(() => {
    if (!canSwitch) {
      clearTenantSession();
      setTenant(null);
      return;
    }
    setTenant(readTenantSession());
  }, [canSwitch]);

  const selectTenant = useCallback((tenant: Tenant | null) => {
    writeTenantSession(tenant);
    setTenant(tenant);
  }, []);

  return {
    tenant,
    canSwitch,
    hasTenant: canSwitch ? tenant !== null : Boolean(user?.tenant),
    selectTenant,
  };
}
